// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"440":"e4015a14","788":"27a3612b"}[chunkId] + ".css";
};